import React, { useEffect, useState } from 'react';
import SurveyForm from './form';
import { useParams } from 'react-router-dom';
import Loading from '../../components/general/loading/loading';
import { asyncGetSurvey } from '../../../services/survey.service';
import { asyncGetProjects } from '../../../services/project.service';
import {
    BodyProject,
    ProjectInterface,
} from '../../../shared/types/project.interface';
import { SurveyList } from '../../../shared/types/survey.interface';

const SurveyEdit = () => {
    const { idSurvey } = useParams();
    const [row, setRow] = useState<any>(undefined);
    const [loading, setLoading] = useState<boolean>(true);
    const [save, setSave] = useState<boolean>(false);
    const [projects, setProjects] = useState<SurveyList[]>([]);

    useEffect(() => {
        if (row === undefined || save) {
            asyncGetSurvey(idSurvey).then((bodySurvey: any) => {
                if (bodySurvey.items !== undefined) {
                    const survey = bodySurvey.items;
                    asyncGetProjects().then((body: BodyProject) => {
                        if (body.items !== undefined) {
                            if (survey.projectIds != null) {
                                const valuesformuser = survey.projectIds.map(
                                    (item: ProjectInterface) => ({
                                        id: item.id,
                                        name: item.nameProject,
                                    })
                                );
                                bodySurvey.items.projectIds = valuesformuser;
                            } else {
                                bodySurvey.items.projectIds = [];
                            }
                            setProjects(
                                body.items.items.map((item) => ({
                                    id: item.id,
                                    name: item.nameProject,
                                }))
                            );
                            setRow(bodySurvey.items);
                            setLoading(false);
                        }
                    });
                }
            });
        }
    }, [idSurvey, row, save]);

    return loading ? (
        <Loading />
    ) : (
        <SurveyForm
            idSurvey={idSurvey}
            surveyInfo={row}
            projects={projects}
            onSave={(value: any) => setSave(value)}
        />
    );
};

export default SurveyEdit;
